import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { clsx } from 'clsx';

/**
 * KYS agent çıktıları için Markdown renderer.
 *
 * - GFM uzantısı: tablolar, görev listeleri, autolinks
 * - Tailwind typography (prose) ile başlık/liste/quote/code stilleri
 * - Dark mode: prose-invert (Layout'ta dark class'ı toggle ediyor)
 * - Kod blokları monospace + slate background — KYS'da SQL/regex göstermek için
 */
export function Markdown({
  children,
  className,
}: {
  children: string;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        'prose prose-sm max-w-none dark:prose-invert',
        // Tailwind typography defaults çok büyük margin verir — sıkıştır
        'prose-p:my-2 prose-ul:my-2 prose-ol:my-2 prose-li:my-0.5',
        'prose-headings:mt-3 prose-headings:mb-1.5 prose-headings:font-semibold',
        'prose-table:my-3 prose-th:text-left prose-th:font-semibold prose-td:py-1 prose-th:py-1',
        // kod
        'prose-code:rounded prose-code:bg-slate-200 prose-code:px-1 prose-code:py-0.5 prose-code:text-[0.85em] prose-code:font-mono prose-code:before:hidden prose-code:after:hidden dark:prose-code:bg-slate-800',
        'prose-pre:bg-slate-900 prose-pre:text-slate-100 dark:prose-pre:bg-slate-800',
        // blockquote
        'prose-blockquote:border-brand-400 prose-blockquote:bg-brand-50/40 prose-blockquote:px-3 prose-blockquote:py-1 prose-blockquote:not-italic dark:prose-blockquote:bg-brand-950/30',
        'prose-a:text-brand-600 dark:prose-a:text-brand-300',
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  );
}
